<template>
<div class="fc-center"><nav class="fc-breadcrumb" aria-label="页面位置"><router-link to="/home/index">首页</router-link><v-icon size="13">mdi-chevron-right</v-icon><span>财务中心</span><v-icon size="13">mdi-chevron-right</v-icon><span>课时账户中心</span></nav><header class="fc-heading"><div><h1>课时账户中心</h1><p>管理学员课时余额、缴费订单与账户变动</p></div><span class="fc-heading-symbol"><v-icon size="26" color="#d9363e">mdi-wallet-outline</v-icon></span></header><v-tabs class="fc-tabs" v-model="tab" color="#d9363e" background-color="transparent" show-arrows><v-tabs-slider color="#d9363e" /><v-tab>课时账户余额</v-tab><v-tab>课时缴费订单</v-tab><v-tab>课时流水查询</v-tab><v-tab>手工划课订单</v-tab><v-tab>退费订单查询</v-tab></v-tabs><v-tabs-items class="fc-tab-panels" v-model="tab"><v-tab-item><accountList /></v-tab-item><v-tab-item><courseRecharge /></v-tab-item><v-tab-item><accountJournal /></v-tab-item><v-tab-item><reduceOrderList /></v-tab-item><v-tab-item><refundOrderList /></v-tab-item></v-tabs-items></div>
</template>

<script>
	import global from '../../../config/global'
	import accountList from "./student_account_list.vue"
	import courseRecharge from "./course_recharge_list.vue"
	import accountJournal from "./account_journal_list.vue"
	import refundOrderList from "./course_refund_order.vue"
	import reduceOrderList from "./course_reduce_order.vue"
	export default {
		name: "course-account-index",
		components:{accountList,courseRecharge,accountJournal,refundOrderList,reduceOrderList},
		data() {
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/home/index"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '学员课时账户中心',
						disabled: true
					},
				],
				tab:null,
				
				
			}
		},
		created() {
		
		},
		
		methods: {
			
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/course-account.scss"></style>
